{
    "component-card-search-list.empty-state.title.non-final": "<strong>Propojení tohoto úložiště se softwarovou komponentou</strong>",
    "component-card.add-chat-channel": "Přidat chatový kanál",
    "component-card.chat-channels": "Chatové kanály",
    "component-card.expander.show-more-link": "Zobrazit více (+{formattedCount})"
}
